import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Button from '../../../../../../../common/widgets/Button';
import Dialog from '../../../../../../../common/widgets/Dialog';
import { rewriteImageUrl } from '../../../../../helpers';
import { resources } from '../../../../../resources/resources';

interface SuccessDialogProps {
  mainImage?: string;
}

export const SuccessDialog = ({ mainImage }: SuccessDialogProps) => {
  const navigateTo = useNavigate();
  const { t: translate } = useTranslation();
  const closeDialog = () => {
    navigateTo('/my-account/cards');
  };
  return (
    <Dialog
      closeDialog={closeDialog}
      showCloseIcon
      closeOnClickOutside
      className="dialog-s topup-success-dialog"
    >
      <div className="dialog-content">
        <div className="dialog-image">
          <img
            src={rewriteImageUrl(mainImage)}
            alt={translate(
              resources.employeeCards.topUp.confirmationDialog.title,
            )}
          />
        </div>
        <div className="dialog-title">
          {translate(resources.employeeCards.topUp.confirmationDialog.title)}
        </div>
        <div className="dialog-text centered">
          {translate(resources.employeeCards.topUp.confirmationDialog.message)}
        </div>
      </div>
      <div className="dialog-actions vertical">
        <Button onClick={closeDialog} className="btn btn-outline">
          {translate(resources.understood)}
        </Button>
      </div>
    </Dialog>
  );
};
